<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <spinner v-if="activateSpinner"></spinner>
        <fieldset v-else>
          <legend class="sr-only">{{ $t('common.global_config.parameters') || 'Paramètres de configuration' }}</legend>
          <b-row>
            <b-col class="form-group">
              <form-card-wrapper
                :label="$t('common.global_config.parameter_GDR')"
                controlId="global-config-gdr-checkbox"
                :statusText="listItemsGlobalConfig.length > 0 && listItemsGlobalConfig[0].Value == 1
                  ? $t('common.global_config.value_non_missing')
                  : $t('common.global_config.value_missing')"
                :hasControl="true">
                <template slot="control">
                  <input 
                    type="checkbox"
                    v-model="Value" 
                    :checked="listItemsGlobalConfig.length > 0 && listItemsGlobalConfig[0].Value == 1"
                    id="global-config-gdr-checkbox"
                    class="form-check-input">
                </template>
              </form-card-wrapper>
            </b-col>
          </b-row>
        </fieldset>
      </b-container>
    </template>
    
    <template slot="bottomActions">
      <app-button
        v-if="isEditable && formType !== 'add'"
        :text="$t('common.cncl')"
        variant="secondary"
        :outline="true"
        size="md"
        custom-class="mr-3"
        :aria-label="$t('common.cncl') + ' ' + $t('Webheader.global_config')"
        @click="switchMode('details')"
      />
      <app-button
        v-if="formType !== 'add'"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="success"
        size="md"
        :aria-label="$t('common.sve') + ' ' + $t('Webheader.global_config')"
        @click="editGlobalConfig"
      />
      <app-button
        v-if="formType === 'add'"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="success"
        size="md"
        :aria-label="$t('common.sve') + ' ' + $t('Webheader.global_config')"
        @click="addGlobalConfig"
      />
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import Spinner from '@/components/common/spinner.vue'
import AppButton from '@/components/common/AppButton.vue'
import FormCardWrapper from '@/components/common/FormCardWrapper.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "GlobalConfigPage",
  components: {
    'page-outline': PageOutline,
    'spinner': Spinner,
    AppButton,
    'form-card-wrapper': FormCardWrapper
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.global_config')
        case 'details':
          return this.$t('Webheader.global_config')
        case 'add':
        default:
          return this.$t('Webheader.global_config')
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      Value: false,
      currentGlobalConfig: {},
      listItemsGlobalConfig: [],
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode
    this.getGlobalConfig()

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getGlobalConfig()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addGlobalConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Name: 'GDR',
        Value: this.Value === true ? 1 : 0
      }
      this.$engine.firstOn().globalConfig.addGlobalConfig(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.global_config.parameter_GDR_enabled'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        this.getGlobalConfig()
        loadPage(that, {url: '/globalConfig/'})
      })
      .catch((e) => {
        errorMessageAlert(e, that)
      })
    },
    editGlobalConfig () {
      let that = this
      let params = {
        Name: 'GDR',
        Value: this.Value === true ? 1 : 0
      }

      this.$engine.firstOn().globalConfig.editGlobalConfig(params)
      .then(resp => {
        let message = this.Value ?
          that.$t('common.global_config.parameter_GDR_enabled') :
          that.$t('common.global_config.parameter_GDR_disabled')

        that.$f7.modal({
          title: message,
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        this.getGlobalConfig()
        loadPage(that, {url: '/globalConfig/'})
      })
      .catch((e) => {
        errorMessageAlert(e, that)
      })
    },
    fillFields () {
      this.config = this.currentGlobalConfig
      this.originalConfig = this.currentGlobalConfig
      this.activateSpinner = false
    },
    formHasError () {
      if (this.Value === false) {
        this.okMessageBox(this.$t('common.global_config.value_missing'))
        return true
      }
      return false
    },
    getGlobalConfig () {
      let that = this
      let params = {
        Name: 'GDR',
      }
      this.$engine.firstOn().globalConfig.getGlobalConfig(params)
      .then(resp => {
        let that = this
        let globalConfigList = {}

        globalConfigList = resp.data.GlobalConfig || []

        that.updateGlobalConfig(globalConfigList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateGlobalConfig(globalConfigList) {
      this.listItemsGlobalConfig = globalConfigList || []
      this.Value = this.listItemsGlobalConfig.length > 0 && this.listItemsGlobalConfig[0].Value == 1
      if (this.listItemsGlobalConfig.length > 0 && this.listItemsGlobalConfig[0].Name === 'GDR') {
        this.formType = 'details'
      } else {
        this.formType = 'add'
      }
      this.fillFields()
    }
  }
}
</script>
